import type { ReactNode } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

type SitStatWidgetCardProps = {
  title: string;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  dragHandle?: ReactNode;
  onRemove?: () => void;
  /** `data-tour` on the card, for product tours. */
  tour?: string;
};

export function SitStatWidgetCard({
  title,
  children,
  className,
  contentClassName,
  dragHandle,
  onRemove,
  tour,
}: SitStatWidgetCardProps) {
  return (
    <Card
      size="sm"
      className={cn('tw:overflow-hidden tw:shadow-sm', className)}
      data-tour={tour}
    >
      <CardHeader className="tw:flex tw:flex-row tw:items-center tw:gap-2 tw:space-y-0 tw:border-b tw:px-3 tw:py-2">
        {dragHandle}
        <CardTitle className="tw:min-w-0 tw:flex-1 tw:truncate tw:text-sm tw:font-semibold">
          {title}
        </CardTitle>
        {onRemove ? (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="tw:h-7 tw:w-7 tw:shrink-0"
            aria-label={`Remove ${title}`}
            onClick={onRemove}
          >
            <X className="tw:h-3.5 tw:w-3.5" />
          </Button>
        ) : null}
      </CardHeader>
      <CardContent className={cn('tw:px-3 tw:py-3', contentClassName)}>
        {children}
      </CardContent>
    </Card>
  );
}
